import { TranslationMessages } from 'ra-core';
import frenchMessages from 'ra-language-french';

const customFrenchMessages: TranslationMessages = {
    ...frenchMessages,
    global: {
        auth: {
            email: 'Email',
            sign_in: 'Entrer',
            password: 'Mot de Pass',
            sign_in_error: "Erreur d'Authentification Failed",
        },
    },
    pos: {
        search: 'Rechercher',
        configuration: 'Configuration',
        language: 'Langue',
        theme: {
            name: 'Theme',
            light: 'Clair',
            dark: 'Obscur',
        },
        dashboard: {
            monthly_revenue: 'CA à 30 jours',
            month_history: "Chiffre d'affaire sur 30 jours",
            new_orders: 'Nouvelles commandes',
            pending_reviews: 'Commentaires à modérer',
            new_customers: 'Nouveaux clients',
            pending_orders: 'Commandes à traiter',
            order: {
                items:
                    'par %{customer_name}, un produit |||| par %{customer_name}, %{nb_items} produits',
            },
            welcome: {
                title: 'Bienvenu chez Sothema',
                subtitle:
                    'SOTHEMA est un laboratoire pharmaceutique 100% marocain, spécialisé dans la fabrication et la commercialisation des médicaments depuis 1976. SOTHEMA représente 35 laboratoires commettants parmi les leaders au Monde dans la Recherche & Développement.',
                aor_button: 'Site web du SOTHEMA',
                demo_button: 'Site web du SOTHEMA',
            },
        },
        menu: {
            sales: 'Ventes',
            catalog: 'Catalogue',
            users: 'Utilisateurs',
            annuaire: 'Annuaire',
        },
    },
    resources: {
        users: {
            name: 'Commercial |||| Commerciaux',
            fields: {
                firstName: 'Prénom',
                lastName: 'Nom',
                email: 'Email',
                emailValidated: 'Email validé',
                promoBox: 'Boite de promo',
                accountEnabled: 'Activé',
                accountEnabledByAdmin: 'Activé par admin',
                isRegional: 'Responsable régional',
                isNational: 'Responsable national',
                phone: 'Tél',
                address1: 'Adresse',
                city: 'Ville',
                country: 'Pays',
                socialReason: 'Raison Sociale',
                created_at: 'Crée le',
                updated_at: 'Dernière mise à jour',
                priceCategory: 'Tranche de prix',
                additionalRegions: 'Additinal regions',
                commands: 'Commandes',
                groups: 'Segments',
                total_spent: 'Dépenses',
                password: 'Mot de passe',
                confirm_password: 'Confirmez le mot de passe',
            },
            filters: {
                last_visited: 'Dernière visite',
                today: "Aujourd'hui",
                this_week: 'Cette semaine',
                last_week: 'La semaine dernière',
                this_month: 'Ce mois-ci',
                last_month: 'Le mois dernier',
                earlier: 'Plus tôt',
                has_ordered: 'A déjà commandé',
                has_newsletter: 'Abonné newsletter',
                group: 'Segment',
            },
            fieldGroups: {
                identity: 'Identité',
                phone: 'Tél',
                address: 'Adresse',
                pricing: 'Tarification',
                history: 'Historique',
                password: 'Mot de passe',
                change_password: 'Changer le mot de passe',
            },
            page: {
                delete: 'Supprimer le client',
            },
            errors: {
                password_mismatch:
                    'La confirmation du mot de passe est différent du mot de passe.',
            },
        },
        admins: {
            name: 'Administrateur |||| Administrateurs',
            fields: {
                firstName: 'Prénom',
                lastName: 'Nom',
                image: 'Image',
                email: 'Email',
                phone: 'Tél',
                address1: 'Adresse',
                city: 'Ville',
                country: 'Pays',
                socialReason: 'Raison Sociale',
                created_at: 'Crée le',
                updated_at: 'Dernière mise à jour',
                priceCategory: 'Tranche de prix',

                commands: 'Commandes',
                groups: 'Segments',
                total_spent: 'Dépenses',
                password: 'Mot de passe',
                confirm_password: 'Confirmez le mot de passe',
            },
            filters: {
                last_visited: 'Dernière visite',
                today: "Aujourd'hui",
                this_week: 'Cette semaine',
                last_week: 'La semaine dernière',
                this_month: 'Ce mois-ci',
                last_month: 'Le mois dernier',
                earlier: 'Plus tôt',
                has_ordered: 'A déjà commandé',
                has_newsletter: 'Abonné newsletter',
                group: 'Segment',
            },
            fieldGroups: {
                image: 'Image',
                identity: 'Identité',
                phone: 'Tél',
                address: 'Adresse',
                pricing: 'Tarification',
                history: 'Historique',
                password: 'Mot de passe',
                change_password: 'Changer le mot de passe',
            },
            image: {
                upload_several:
                    'Glissez des photos à uploader ou cliquez pour en sélectionner une.',
                upload_single:
                    'Glissez une photo à uploader ou cliquez pour la sélectionner.',
            },
            page: {
                delete: 'Supprimer le client',
            },
            errors: {
                password_mismatch:
                    'La confirmation du mot de passe est différent du mot de passe.',
            },
        },
        magasiniers: {
            name: 'Magasinier |||| Magasiniers',
            fields: {
                firstName: 'Prénom',
                lastName: 'Nom',
                image: 'Image',
                email: 'Email',
                phone: 'Tél',
                address1: 'Adresse',
                city: 'Ville',
                country: 'Pays',
                socialReason: 'Raison Sociale',
                created_at: 'Crée le',
                updated_at: 'Dernière mise à jour',
                priceCategory: 'Tranche de prix',
                currentSite: 'Chantier Actuel',

                commands: 'Commandes',
                groups: 'Segments',
                total_spent: 'Dépenses',
                password: 'Mot de passe',
                confirm_password: 'Confirmez le mot de passe',
            },
            filters: {
                last_visited: 'Dernière visite',
                today: "Aujourd'hui",
                this_week: 'Cette semaine',
                last_week: 'La semaine dernière',
                this_month: 'Ce mois-ci',
                last_month: 'Le mois dernier',
                earlier: 'Plus tôt',
                has_ordered: 'A déjà commandé',
                has_newsletter: 'Abonné newsletter',
                group: 'Segment',
            },
            fieldGroups: {
                image: 'Image',
                identity: 'Identité',
                site: 'Chantier en cours',
                phone: 'Tél',
                address: 'Adresse',
                pricing: 'Tarification',
                history: 'Historique',
                password: 'Mot de passe',
                change_password: 'Changer le mot de passe',
            },
            image: {
                upload_several:
                    'Glissez des photos à uploader ou cliquez pour en sélectionner une.',
                upload_single:
                    'Glissez une photo à uploader ou cliquez pour la sélectionner.',
            },
            page: {
                delete: 'Supprimer le client',
            },
            errors: {
                password_mismatch:
                    'La confirmation du mot de passe est différent du mot de passe.',
            },
        },

        packs: {
            name: 'Demande |||| Demandes',
            fields: {
                pharmacy: 'Pharmacie',
                ice: 'ICE',
                status: 'Statut',
                justificatifStatus: 'Statut du justificatif',
                justificatif: 'Justificatif',
                images: 'Images',
                nature: 'Nature',
                city: 'Ville',
                region: 'Région',
                phone: 'Tél',
                number: 'Nombre de Packs',
                quantity: 'Quantité',
                bl: 'Numéro BL',
                bl1: 'Numéro BL 2',
                bl2: 'Numéro BL 3',
                bl3: 'Numéro BL 4',
                grossiste: 'Grossiste',
                montantBonAchat: "Montant Bon d'Achat",
                date: 'Date BL',
                created_at: 'Crée le',
                updated_at: 'Dernière mise à jour',
                created_by: 'Commercial',
            },
            filters: {
                last_visited: 'Dernière visite',
                today: "Aujourd'hui",
                this_week: 'Cette semaine',
                last_week: 'La semaine dernière',
                this_month: 'Ce mois-ci',
                last_month: 'Le mois dernier',
                earlier: 'Plus tôt',
                has_ordered: 'A déjà commandé',
                has_newsletter: 'Abonné newsletter',
                group: 'Segment',
            },
            fieldGroups: {
                image: 'Image',
                identity: 'Identité',
                phone: 'Tél',
                address: 'Adresse',
                pricing: 'Tarification',
                history: 'Historique',
                password: 'Mot de passe',
                change_password: 'Changer le mot de passe',
            },
            image: {
                upload_several:
                    'Glissez des photos à uploader ou cliquez pour en sélectionner une.',
                upload_single:
                    'Glissez une photo à uploader ou cliquez pour la sélectionner.',
            },
            page: {
                delete: 'Supprimer le client',
            },
            errors: {
                password_mismatch:
                    'La confirmation du mot de passe est différent du mot de passe.',
            },
        },
        archive: {
            name: 'Archive |||| Archive',
            fields: {
                pharmacy: 'Pharmacie',
                ice: 'ICE',
                status: 'Statut',
                justificatifStatus: 'Statut du justificatif',
                justificatif: 'Justificatif',
                images: 'Images',
                nature: 'Nature',
                city: 'Ville',
                region: 'Région',
                phone: 'Tél',
                number: 'Nombre de Packs',
                quantity: 'Quantité',
                bl: 'Numéro BL',
                grossiste: 'Grossiste',
                montantBonAchat: "Montant Bon d'Achat",
                date: 'Date BL',
                created_at: 'Crée le',
                updated_at: 'Dernière mise à jour',
                created_by: 'Commercial',
            },
            filters: {
                last_visited: 'Dernière visite',
                today: "Aujourd'hui",
                this_week: 'Cette semaine',
                last_week: 'La semaine dernière',
                this_month: 'Ce mois-ci',
                last_month: 'Le mois dernier',
                earlier: 'Plus tôt',
                has_ordered: 'A déjà commandé',
                has_newsletter: 'Abonné newsletter',
                group: 'Segment',
            },
            fieldGroups: {
                image: 'Image',
                identity: 'Identité',
                phone: 'Tél',
                address: 'Adresse',
                pricing: 'Tarification',
                history: 'Historique',
                password: 'Mot de passe',
                change_password: 'Changer le mot de passe',
            },
            image: {
                upload_several:
                    'Glissez des photos à uploader ou cliquez pour en sélectionner une.',
                upload_single:
                    'Glissez une photo à uploader ou cliquez pour la sélectionner.',
            },
            page: {
                delete: 'Supprimer le client',
            },
            errors: {
                password_mismatch:
                    'La confirmation du mot de passe est différent du mot de passe.',
            },
        },
        promobox: {
            name: 'Boite de promo |||| Boites de promo',
            fields: {
                name: 'Nom',
                products: 'Produits',
                created_at: 'Crée le',
                updated_at: 'Dernière mise à jour',
            },
        },
    },
};

export default customFrenchMessages;
